<template>
  <layout-auth message="Join the Team!" :width="620">
    <div class="columns is-multiline mt-200">
      <div class="column is-6">
        <form-field-input
          label="First Name"
          v-model="acceptUserInviteForm.first_name"
          :validation-errors="validationErrors.first_name"
          size=""
          v-autofocus
        ></form-field-input>
      </div>

      <div class="column is-6">
        <form-field-input
          label="Last Name"
          v-model="acceptUserInviteForm.last_name"
          :validation-errors="validationErrors.last_name"
          size=""
        ></form-field-input>
      </div>

      <div class="column is-12">
        <form-field-password
          label="Password"
          v-model="acceptUserInviteForm.password"
          :validation-errors="validationErrors.password"
          size=""
        ></form-field-password>
      </div>

      <div class="column is-6">
        <form-field-phone
          label="Phone Number"
          v-model="acceptUserInviteForm.notifications_phone_number"
          :validation-errors="validationErrors.notifications_phone_number"
          size=""
        ></form-field-phone>
      </div>

      <div class="column is-6">
        <form-field-timezones
          :validation-errors="validationErrors"
          :entity="acceptUserInviteForm"
          size=""
        ></form-field-timezones>
      </div>
    </div>

    <div class="has-text-centered">
      <button-default
        @click="formSubmit"
        :loading="isSaving"
        :disabled="isSaving"
        size=""
        class="auth_button"
      >Accept Invitation</button-default>
    </div>
  </layout-auth>
</template>

<script>
import router from "../../router";

export default {
  name: "AcceptInvitePage",
  metaInfo: {
    title: "Accept Invite"
  },
  data() {
    return {
      isSaving: false,
      validationErrors: {},
      userInvite: null,
      acceptUserInviteForm: {
        token: null,
        first_name: '',
        last_name: '',
        timezone: '',
        password: '',
        notifications_phone_number: '',
      },
    }
  },
  created() {
    this.$api.userInvites.getInviteByEncryptedToken(this.$route.params.inviteToken).then((response) => {
      this.userInvite = response.data;
      this.acceptUserInviteForm.token = this.$route.params.inviteToken;
    });
  },
  mounted() {
    this.acceptUserInviteForm.timezone = 'America/Chicago';
  },
  methods: {
    formSubmit() {
      this.isSaving = true;
      this.$api.userInvites.acceptInvite(this.acceptUserInviteForm).then(() => {
        this.validationErrors = {}
        router.push({ name: 'pipeline' });
      }, error => {
        if (error.response.status === 422) this.validationErrors = error.response.data.errors;
      }).finally(() => {
        this.isSaving = false;
      });
    }
  }
}
</script>
